import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { budgetApi } from 'src/Services/API';

/**
 * What the wizard starts from: N−1 fixed costs per category, the N−1 daily-life envelope with
 * its per-sub-category detail, and the projects still « À voter » / « Boîte à idées ».
 */
const useBudgetSuggestions = (year: number, enabled = true) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['budget', assetId, year, 'suggestions'],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await budgetApi.budgetControllerGetSuggestions(assetId, year)).data;
    },
    enabled: !!assetId && enabled,
  });
};

export default useBudgetSuggestions;
